import React, { useState } from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CardMedia,
  Box,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const EducationalMaterial = ({ title, link }) => (
  <Card sx={{ mb: 2 }}>
    <CardContent>
      <Typography variant="h6">{title}</Typography>
      <Button
        variant="contained"
        color="primary"
        href={link}
        target="_blank"
        sx={{ mt: 1 }}
      >
        Download
      </Button>
    </CardContent>
  </Card>
);

const Resources = () => {
  const blogData = [
    {
      id: 1,
      title: "Know Your Government",
      description:
        "Tamil Nadu e-Governance Agency is developing a web and mobile application platform",
      image: "./images/blog1.jpg",
      createdDate: "01-09-2020",
      fullContent:
        "Tamil Nadu e-Governance Agency is developing a web and mobile application platform called “Know Your Government” to provide services of accessing the Government Facilities on a GIS enabled Map, in which, the general public can search and access any Government facilities such as Police Stations, Health Care Facilities, Govt. Schools, etc that are close to their proximity.",
    },
    {
      id: 2,
      title: "Share your Ideas Coronavirus",
      description:
        "The MyGov Tamil Nadu portal of the government has started discussion",
      image: "./images/blog2.jpg",
      createdDate: "01-09-2020",
      fullContent:
        "The MyGov Tamil Nadu portal of the government has started discussion on ways to check the spread of the virus. In order to involve the community in the fight against the Virus, we would want you to share your ideas and suggestions to help fight #Coronavirus.",
    },
    {
      id: 3,
      title: "Eco Tourism",
      description:
        "Share your suggestions / ideas to make Chennai an Eco-tourism destination.",
      image: "./images/blog3.jpg",
      createdDate: "30-11-2020",
      fullContent:
        "Share your suggestions / ideas to make Chennai an Eco-tourism destination.",
    },
    {
      id: 4,
      title: "Suggestions to reduce Plastics",
      description:
        "It is summer vacation now and tourist season in Tamil Nadu has begun.",
      image: "./images/blog4.jpg",
      createdDate: "21-05-2022",
      fullContent:
        "It is summer vacation now and tourist season in Tamil Nadu has begun. People from all over India visit popular hill stations like Ooty, Kodaikanal and Yercaud. The Government is doing its best to protect the environment from the menace of plastic. We invite your suggestions on how to reduce plastic usage by tourists and what are the alternatives. Please do share your valuable suggestions here on MyGoVTamil Nadu portal. The last date for submissions is 21.05.2022.",
    },
  ];

  const newsData = [
    {
      id: 1,
      title: "U.P., Bihar were never ‘Hindi heartlands’",
      description:
        "DMK president and Tamil Nadu Chief Minister M.K. Stalin on Thursday (February 27, 2025)",
      createdDate: "February 27, 2025",
      fullContent:
        "DMK president and Tamil Nadu Chief Minister M.K. Stalin on Thursday (February 27, 2025) charged that the push for a monolithic Hindi identity “killed ancient mother tongues.” Languages that gave space for Hindi eventually got lost without any trace, he claimed.",
    },
    {
      id: 2,
      title: "Forest dept. urges farmers to relocate goat sheds..",
      description:
        "A Forest Department staffer hands over a pamphlet to a farmer in Chennimalai..",
      createdDate: "February 27, 2025 ",
      fullContent:
        "A Forest Department staffer hands over a pamphlet to a farmer in Chennimalai in Erode district in Tamil Nadu on Wednesday | Photo Credit: Special Arrangement",
    },
    {
      id: 3,
      title: "Rameswaram fishermen to go on strike from February 28",
      description:
        "The fishermen leaders at the meeting said they would not venture into the sea unless..",
      createdDate: "October 1, 2023",
      fullContent:
        "A peace committee meeting between officials of the Revenue, Police and Fisheries departments and leaders of fishermen associations was convened in Rameswaram on Thursday (February 27, 2025) to convince the latter to drop or postpone their proposed indefinite hunger strike from Friday (February 28, 2025). The talks, however, failed, with the associations going ahead with the strike in protest against the frequent arrests of fishermen and the seizing of their trawlers by the Sri Lankan Navy.",
    },
    {
      id: 4,
      title: "Student group to stage black flag protest against Education",
      description:
        "The organisation, in a statement, said the protest was to the Union government",
      createdDate: "October 10, 2023",
      fullContent:
        "The Federation of Student Organisations-Tamil Nadu (FSO-TN) has announced it would stage a ‘black flag’ protest against Union Minister of State for Education Sukanta Majumdar’s visit to Indian Institute of Technology-Madras (IIT-M) on Friday (February 28, 2025).",
    },
  ];

  const educationalMaterials = [
    {
      title: "State Council of Educational Research - Class-I",
      link: "https://d1e5r329t7a85t.cloudfront.net/syllabuspdf/1st_Tamil_CBSE.pdf",
    },
    {
      title: "State Council of Educational Research - Class-X",
      link: "https://d1e5r329t7a85t.cloudfront.net/syllabuspdf/10th_Tamil_Text.pdf",
    },
  ];
  const [open, setOpen] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);

  // Handle dialog open
  const handleClickOpen = (blog) => {
    setSelectedBlog(blog);
    setOpen(true);
  };

  // Handle dialog close
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box id="resources" sx={{ background: "black", color: "white", py: 5 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Resources
      </Typography>
      <Container>
        <Grid container spacing={3}>
          {/* Blogs & Articles Section */}
          <Grid item xs={12} md={12}>
            <Typography variant="h5" component="h5" gutterBottom>
              Blogs & Articles
            </Typography>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              navigation={false}
              pagination={false}
              autoplay={{ delay: 3000 }}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {blogData.map((blog) => (
                <SwiperSlide key={blog.id}>
                  <Card style={{ maxWidth: 345, margin: "10px auto" }}>
                    <CardMedia
                      component="img"
                      height="140"
                      image={blog.image}
                      alt={blog.title}
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h6" component="div">
                        {blog.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {blog.description}
                      </Typography>
                      <Typography variant="caption" display="block" mt={1}>
                        Created: {blog.createdDate}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleClickOpen(blog)}
                        style={{ marginTop: "10px" }}
                      >
                        Read More
                      </Button>
                    </CardContent>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>

          {/* News Updates Section */}
          <Grid item xs={12} md={12}>
            <Typography variant="h6" component="h5" gutterBottom>
              News Updates
            </Typography>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              navigation={false}
              pagination={false}
              autoplay={{ delay: 3000 }}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {newsData.map((news) => (
                <SwiperSlide key={news.id}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px auto",
                    }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Typography variant="h6" component="h3" gutterBottom>
                        {news.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        gutterBottom
                      >
                        {news.createdDate}
                      </Typography>
                      <Typography variant="body1" paragraph>
                        {news.description}
                      </Typography>
                    </CardContent>
                    <Button
                      variant="outlined"
                      color="primary"
                      sx={{ m: 2 }}
                      onClick={() => handleClickOpen(news)}
                    >
                      Read More
                    </Button>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>

          {/* Educational Materials Section */}
          <Grid item xs={12} md={12}>
            <Typography variant="h5" component="h5" gutterBottom>
              Educational Materials
            </Typography>
            <Grid container spacing={3}>
              {educationalMaterials.map((material, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <EducationalMaterial {...material} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        {/* Dialog for full blog details */}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>{selectedBlog?.title}</DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom>
              {selectedBlog?.fullContent}
            </Typography>
            <Typography variant="caption" display="block" mt={2}>
              Created: {selectedBlog?.createdDate}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
};

export default Resources;
